// extracted by mini-css-extract-plugin
export default {"name":"_1d9c7c8430d38632"};